module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"contactUs":"Contact Us","siteMap":"Sitemap","copyright":"Copyright © {year} | All Rights Reserved.","privacyNotice":"Privacy notice"},"es-MX":{"contactUs":"Contáctanos","siteMap":"Mapa del Sitio","copyright":"Copyright © {year} | Reservados todos los derechos.","privacyNotice":"Aviso de privacidad"}}')
  delete Component.options._Ctor
}
